<template>
  <div id="alreadyApproved" class="common_contentBox">
    <commonHeader
      :tabs-list="tabsList"
      :tabs-default="form.activityStatus"
      @handleTabsClick="handleTabsClick"
      :breadcrumb-show="false"
      v-if="$store.state.userInfo.userType === 'rj'"
    />
    <div class="common_search">
      <el-row>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">{{ $t('approvalCenter.ActivityNumber') }}：</div>
          <div class="content">
            <el-input v-model="form.activityCode" @input="inputBoxFilter($event,'activityCode')" :placeholder="$t('general.pec')" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">{{ $t('approvalCenter.EventName') }}：</div>
          <div class="content">
            <el-input v-model="form.activityName" @input="inputBoxFilter($event,'activityName')" :placeholder="$t('general.pec')" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">{{ $t('approvalCenter.TypeOfActivity') }}：</div>
          <div class="content">
            <el-input v-model="form.activityType" @input="inputBoxFilter($event,'activityType')" :placeholder="$t('general.pec')" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <span class="label">{{ $t('approvalCenter.TheApplicant') }}：</span>
          <div class="content">
            <el-input v-model="form.applyUserNameOrId" :placeholder="$t('general.pec')" @input="inputBoxFilter($event,'applyUserNameOrId')" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <span class="label">{{ $t('eventList.AppStatus') }}：</span>
          <div class="content">
            <el-select v-model="form.approvalStatus" :placeholder="$t('general.pec')" @change="searchBtn">
              <el-option v-for="(item, index) in approvalStatusList" :key="index" :label="item.fieldValue" :value="item.fieldValue" />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <span class="label">{{ $t('approvalCenter.CorrespondingSales') }}：</span>
          <div class="content">
            <el-input v-model="form.salerNameOrId" :placeholder="$t('general.pec')" @input="inputBoxFilter($event,'salerNameOrId')" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <span class="label">{{ $t('approvalCenter.Department') }}：</span>
          <div class="content">
            <el-select
              v-model="form.applyUserDeptNameOrCode"
              filterable
              remote
              clearable
              reserve-keyword
              :placeholder="$t('general.peak')"
              :remote-method="getApplyDeptList"
              :loading="applyLoading"
            >
              <el-option v-for="item in applyDeptList" :key="item.userId" :label="item.deptName" :value="item.deptCode" />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <span class="label">{{ $t('approvalCenter.AttributionExpenses') }}：</span>
          <div class="content">
            <el-select
              v-model="form.expenseDeptNameOrCode"
              filterable
              remote
              clearable
              reserve-keyword
              :placeholder="$t('general.pec')"
              :remote-method="getCostDeptList"
              :loading="applyLoading"
            >
              <el-option v-for="item in costDeptList" :key="item.userId" :label="item.deptName" :value="item.deptCode" />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <div class="label">{{ $t('approvalCenter.TypeFee') }}：</div>
          <div class="content">
            <el-select v-model="form.expenseTypeCode" :placeholder="$t('general.pec')" clearable>
              <el-option v-for="item in expenseTypeList" :key="item.expenseTypeCode" :label="item.expenseTypeName" :value="item.expenseTypeCode" />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-if="isBrandPromotion" v-show="searchOpenFlag">
          <div class="label">{{ $t('approvalCenter.StatusMaterial') }}</div>
          <div class="content">
            <el-select v-model="form.materialConfigStat" :placeholder="$t('general.pec')" clearable>
              <el-option v-for="item in materialStatusList" :key="item.val" :label="item.label" :value="item.val" />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-if="form.activityStatus == 0" v-show="searchOpenFlag">
          <div class="label">{{ $t('industryReport.hybblb.list.bblx') }}：</div>

          <div class="content">
            <el-select v-model="form.reportType" :placeholder="$t('industryReport.hybblb.tsy.bblx')" clearable>
              <el-option v-for="item in reportingTypeList" :key="item.val" :label="item.label" :value="item.val" />
            </el-select>
          </div>
        </el-col>
        <!-- 活动分类 -->
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <div class="label">{{ $t('newApp.activityInfo.coa') }}：</div>
          <div class="content">
            <el-select
              v-model="form.activityClassification"
              clearable
              :placeholder="$t('general.ps')"
              @change="searchBtn"
            >
              <el-option v-for="item in activityClassificationList" :key="item.fieldKey" :label="item.fieldValue" :value="item.fieldKey" />
            </el-select>
          </div>
        </el-col>
        <!-- 总部活动 -->
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <div class="label">{{ $t('newApp.activityInfo.headquarterActivityName') }}：</div>
          <div class="content">
            <el-input v-model="form.hqActivityName" :placeholder="$t('general.pec')" />
          </div>
        </el-col>
        <!-- 模板活动 -->
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <div class="label">{{ $t('newApp.activityInfo.templateActivityName') }}：</div>
          <div class="content">
            <el-input v-model="form.templateActivityName" :placeholder="$t('general.pec')" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" />
        <div class="btnBar">
          <el-button plain @click="reset">{{ $t('btn.Reset') }}</el-button>
          <el-button type="primary" @click="searchBtn">{{ $t('btn.Search') }}</el-button>
        </div>
      </el-row>
      <div class="advancedSearchBtn">
        <span :class="searchOpenFlag ? 'open' : ''" @click="searchOpenFlag = !searchOpenFlag">
          <span>{{ searchOpenFlag ? $t('btn.CollspseS') : $t('btn.AdvancedS') }}</span>
          <i class="iconfont icon-rili4-icon" />
        </span>
      </div>
    </div>
    <commonTable ref="alreadyApproved" />
    <!-- 活动评估 -->
    <assessmentDialog
      :activity-code="currentActivityCode"
      :assessment-dialog-visible="assessmentDialogVisible"
      @dialogCloseHandle="assessmentDialogClose"
      @handlerSuccess="assessmentSuccess"
    />
  </div>
</template>
<script>
import commonHeader from '@/components/commonHeader';
import commonTable from '@/components/commonTable';
import { TableRow, TableColumns } from '@/utils/tableOptions.js';
import assessmentDialog from '../activitieList/component/reportList/assessmentDialog';
import { newApplicationFormApi } from '../newApplicationForm/service';
import { activityQuery } from '../activitieList/service';
import { arrayQuery } from '@/utils/utils';
import { approvalCenterApi } from './service';
export default {
  name: 'AlreadyApproved',
  data () {
    return {
      reportingTypeList: [
        {
          label: this.$t('industryReport.hybblb.cxtj.qybb'),
          val: 1
        },
        {
          label: this.$t('industryReport.hybblb.cxtj.hybb'),
          val: 2
        }
      ],
      tabsList: [
        {
          label: this.$t('approvalCenter.ActivityApplication'),
          name: '1'
        }
      ],
      form: {
        approvalStat: 2, // 已审批
        activityStatus: '1',
        reportType: '' // 报备类型
      },
      searchOpenFlag: false,
      tableData: [],
      assessmentDialogVisible: false,
      currentActivityCode: '',
      approvalStatusList: [],
      activityClassificationList: [],
      applyDeptList: [],
      costDeptList: [],
      expenseTypeList: [],
      materialStatusList: [
        {
          label: this.$t('eventList.Configured'),
          val: '1'
        },
        {
          label: this.$t('eventList.NotCon'),
          val: '0'
        }
      ],
      applyLoading: false,
      isBrandPromotion: false,
      isCompliance: false
    };
  },
  components: {
    commonTable,
    commonHeader,
    assessmentDialog
  },
  computed: {},
  methods: {
    getCostDeptList (expenseKey) {
      if (expenseKey && expenseKey.indexOf(' ') === 0) {
        this.costDeptList = [];
        return;
      }
      expenseKey = expenseKey || 'all';
      let params = {
        type: 'EXPENSE',
        key: expenseKey
      };
      activityQuery.getDeptList(params).then(res => {
        if (res.status === '200') {
          this.costDeptList = res.data;
        }
      });
    },
    getApplyDeptList (applyKey) {
      if (applyKey && applyKey.indexOf(' ') === 0) {
        this.applyDeptList = [];
        return;
      }
      applyKey = applyKey || 'all';
      let params = {
        type: 'APPLAY',
        key: applyKey
      };
      activityQuery.getDeptList(params).then(res => {
        if (res.status === '200') {
          this.applyDeptList = res.data;
        }
      });
    },
    assessmentSuccess () {
      this.assessmentDialogVisible = false;
      this.searchBtn();
    },
    assessmentHandler (row) {
      this.currentActivityCode = row.activityCode;
      this.assessmentDialogVisible = true;
    },
    assessmentDialogClose () {
      this.assessmentDialogVisible = false;
    },
    handleTabsClick (data) {
      this.$set(this.form, 'activityStatus', data.name);
      this.searchBtn();
    },
    inputBoxFilter (val, key) {
      let numVal = val.replace(/^\s+|\s+$/g, '');
      this.$set(this.form, key, numVal);
    },
    approvalHandle (row) {
      // 如果是报备则跳转报备详情，否跳转至活动详情
      if (this.form.activityStatus === '0') {
        let path = '/reportDetails';
        if (row.reportType) {
          path = row.reportType === '1' ? '/regionReportDetails' : '/industryReportDetails';
        }
        this.$router.push({
          path: path,
          query: {
            activityCode: row.activityCode,
            metaActive: '/alreadyApproved'
          }
        });
        return;
      }
      this.$router.push({
        path: '/activityDetails',
        query: {
          activityCode: row.activityCode,
          metaActive: '/alreadyApproved'
        }
      });
    },
    reset () {
      this.form = { approvalStat: 2,
        activityStatus: this.form.activityStatus
       };
      this.searchBtn();
    },
    searchBtn () {
      this.tempForm = JSON.parse(JSON.stringify(this.form));
      if (this.form.approvalStatus) {
        this.tempForm.approvalStatus = arrayQuery(this.form.approvalStatus, this.approvalStatusList, 'fieldValue').fieldKey;
      }
      this.$refs.alreadyApproved.pageData.pageNum = 1;
      if (this.form.activityStatus === '2') {
        this.$refs.alreadyApproved.loadTable({
          url: '/compliance/approve/done_tasks',
          listKey: 'list',
          params: this.tempForm
        });
      } else {
        this.loadTable(this.tempForm);
      }
      // this.$refs.alreadyApproved.getTableData({ url: '/approvecenter/his_tasks', params: this.tempForm });
    },
    loadTable (formData) {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title(this.$t('approvalCenter.ActivityNumber'))
          ._width('12%')
          ._data('activityCode')
          ._fixed('left')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <span class="btnText" type="text" onClick={() => { this.approvalHandle(row); }}>{ row.activityCode }</span>
                </div>
              );
            }
          })
      );
      if (this.form.activityStatus === '1') {
        tableRow.push(
          new TableColumns()
            ._width('120')
            ._title(this.$t('eventList.Afc'))
            ._cellType('customDom')
            ._cellData({
              formater: ({ row, column }) => {
                let text = this.$t('approvalCenter.ActivityApplication');
                switch (row.submitType) {
                  case 'report_submit':
                    text = this.$t('home.aff');
                    break;
                  case 'quick_submit':
                    text = this.$t('home.qa');
                    break;
                  case 'qd_submit':
                    text = this.$t('home.ca');
                    break;
                }
                return (
                  <div>{ text }</div>
                );
              }
            })
        );
      }
      tableRow.push(
        new TableColumns()
          ._title(this.$t('approvalCenter.TheApplicant'))
          ._width('8%')
          ._data('applyUserName')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('approvalCenter.CorrespondingSales'))
          ._width('8%')
          ._data('salerName')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('eventList.Department'))
          ._width('10%')
          ._data('salerDeptName')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('approvalCenter.EventName'))
          ._width('18%')
          ._data('activityName')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('approvalCenter.TypeOfActivity'))
          ._width('11%')
          ._data('activityType')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('approvalCenter.TimeApplication'))
          ._width('8%')
          ._data('applyTime')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let date = row[column.property] ? new Date(row[column.property].replace(/-/g, '/')).format('yyyy-MM-dd') : '';
              return (
                <span>{ date }</span>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('approvalCenter.MarketingExpenses'))
          ._width('8%')
          ._align('right')
          ._data('marketingCost')
      );
      tableRow.push(
        new TableColumns()
          ._width('10%')
          ._title(this.$t('approvalCenter.DegreeImportance'))
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>{ row.importance ? row.importance : this.$t('eventList.NotEva') }</div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._width('8%')
          ._title(this.$t('approvalCenter.AbilityExecute'))
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>{ row.enforceability ? row.enforceability : this.$t('eventList.NotEva') }</div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._width('15%')
          ._title(this.$t('approvalCenter.StrengthSupport'))
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>{ row.supportStrength ? row.supportStrength : this.$t('eventList.NotEva') }</div>
              );
            }
          })
      );
      if (this.isCompliance) {
        tableRow.push(
          new TableColumns()
            ._title(this.$t('eventList.AppStatus'))
            ._width('12%')
            ._data('approvalStat')
        );
      }
      tableRow.push(
        new TableColumns()
          ._title(this.$t('general.Operation'))
          ._width('160')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let userInfo = this.$store.state.userInfo;
              return (
                <div>
                  <el-button type="text" onClick={() => { this.approvalHandle(row); }}>{ this.$t('general.ctView') }</el-button>
                  {
                    userInfo.sysUser.deptCode.indexOf('000013') === 0 ? (
                      <el-button type="text" onClick={ () => { this.assessmentHandler(row); } }>{ this.$t('btn.ActivityE') }</el-button>
                    ) : null
                  }
                </div>
              );
            }
          })
      );
      let column = tableRow._cols();
      this.$refs.alreadyApproved.setColumn(column);
      this.$refs.alreadyApproved.loadTable({ url: '/approvecenter/his_tasks', listKey: 'list', params: formData || this.form });
    },
    getActivityCommonList () {
      if (this.activityClassificationList.length > 0 && this.approvalStatusList.length > 0) {
        return;
      }
      const params = [
        'activity_classification',
        'apply_approval_status'
      ];
      newApplicationFormApi.getActivityList(params).then(res => {
        if (res.status === '200') {
          this.activityClassificationList = res.data.activity_classification || [];
          this.approvalStatusList = res.data.apply_approval_status || [];
        }
      });
    },
    getExpenseTypeList () {
      activityQuery.getExpenseTypeList().then(res => {
        if (res.status === '200') {
          this.expenseTypeList = res.data;
        }
      });
    },
    // 根据合规申请查看权限决定是否增加合规申请tab页签
    getIsCompliance () {
      approvalCenterApi.getComplianceShowPrivilege().then(res => {
        if (res.status === '200') {
          this.isCompliance = res.data;
          if (res.data) {
            this.tabsList.push({
              label: this.$t('approvalCenter.ComplianceApplication'),
              name: '2'
            });
          }
        }
      });
    }
  },
  activated () {
    if (this.form.activityStatus === '2') {
      this.$refs.alreadyApproved.loadTable({
        url: '/compliance/approve/done_tasks',
        listKey: 'list',
        params: this.form
      });
    } else {
      this.loadTable();
    }
    this.getActivityCommonList();
    this.getExpenseTypeList();
  },
  mounted () {
    this.isBrandPromotion = this.$store.state.userInfo.belongToBrandPromotionDept;
    if (this.$store.state.userInfo.userType === 'rj') {
      this.tabsList.unshift({
        label: this.$t('approvalCenter.ReportActivity'),
        name: '0',
        hidden: this.$store.state.useSimplifiedUI
      });
      // 简化UI用户不默认选中报备Tab，保持默认的活动申请Tab
      if (!this.$store.state.useSimplifiedUI) {
        this.form.activityStatus = '0';
      }
    }
    this.getIsCompliance();
    this.getActivityCommonList();
  }
};
</script>
<style lang="scss" scoped>
#alreadyApproved {
  width: 100%;
}
</style>
